import { render } from "./UserPermission.vue?vue&type=template&id=47128024&scoped=true"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"

import "./UserPermission.vue?vue&type=style&index=0&id=47128024&lang=scss&scoped=true"
import "./UserPermission.vue?vue&type=style&index=1&id=47128024&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47128024"]])

export default __exports__